export default "__VITE_ASSET__DP7_nW17__"